import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreMaterialModule } from '@nttp/core-material';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgTableModule } from '@nttp/table/ng-table.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SearchReferralComponent } from '@pg-app/partner/search-referral/containers/search-referral.component';
import { SearchReferralRoutingModule } from '@pg-app/partner/search-referral/search-referral-routing.module';
import { SearchReferralService } from '@pg-app/partner/search-referral/services/search-referral.service';

@NgModule({
  declarations: [SearchReferralComponent],
  imports: [
    SearchReferralRoutingModule,
    CommonModule,
    CoreMaterialModule,
    NgbModule,
    NgTableModule,
    ReactiveFormsModule
  ],
  providers: [SearchReferralService]
})
export class SearchReferralModule {}
